import { axios } from "..";

export interface IReferralType {
    id: string;
    legacyId?: string;
    typeId: string;
    description: string;
    isActive: number;
    displayOrder: number;
}

export const getReferralTypes = async (): Promise<IReferralType[]> => {
    const response = await axios.Get("/referral-types");
    return response.data ?? [];
};

export const addReferralType = async (description: string): Promise<IReferralType> => {
    const response = await axios.Post("/referral-types", { description });
    return response.data;
};
